import React from 'react'
import { Link } from 'react-router-dom'

export const privateNoteColumns = (layout, role) => [
	{
		name: 'Date',
		selector: (row) => row.ndate || '',
		sortable: true,
		width: '10%'
	},
	{
		name: 'Written By',
		selector: (row) => row.instructorName || '',
		sortable: true,
		width: '10%'
	},
	{
		name: 'Student',
		selector: (row) => row.studentName || '',
		sortable: true,
		width: '10%'
	},
	{
		name: 'Note',
		selector: (row) => row.note || '',
		sortable: false,
		width: '45%',
		cell: (row) => <div style={{ wordWrap: 'break-word' }}>{row.note || 'N/A'}</div>
	},
	{
		name: 'Actions',
		selector: (row) => row.id,
		sortable: false,
		width: '25%',
		cell: (row) => (
			<div className="d-flex gap-2">
				<Link to={`${process.env.PUBLIC_URL}/${role}/private-notes/edit/${row.id}/${layout}`} className="btn btn-success btn-sm">
					<i className="fa fa-edit me-1"></i>
				</Link>
				<button className="btn btn-danger btn-sm" onClick={() => row.onDelete && row.onDelete(row.id)}>
					 <i className="fa fa-trash"></i>
				</button>
			</div>
		)
	}
]
